import { Getter, Setter } from '../services/ComService'
import { GLItemStatus } from './GLItemDTO'

export type IGLItemStatusHistory = {
    id: number
    status: GLItemStatus
    date?: string
    userId?: number
    userName?: string
}

export class GLItemStatusHistoryDTO {
    id: number = -1
    status: GLItemStatus = GLItemStatus.generic
    date: string = ''
    userId?: number
    userName?: string

    constructor(data?: IGLItemStatusHistory) {
        if (data) {
            this.init(data)
        }
    }

    init(data: IGLItemStatusHistory) {
        this.id = data.id
        this.status = data.status
        this.date = data.date || ''
        this.userId = data.userId
        this.userName = data.userName
    }

    static async listFromServer(glItemId: number): Promise<GLItemStatusHistoryDTO[]> {
        const result = await Getter(`spt/gl_items/${glItemId}/status_history`) as { data?: IGLItemStatusHistory[] } | undefined
        return (result?.data || []).map(row => new GLItemStatusHistoryDTO(row))
    }

    static async upsert(glItemId: number, status: GLItemStatus, date?: string): Promise<GLItemStatusHistoryDTO> {
        const result = await Setter(`spt/gl_items/${glItemId}/status_history`, {
            status,
            date,
        }) as { data?: IGLItemStatusHistory }
        return new GLItemStatusHistoryDTO(result.data as IGLItemStatusHistory)
    }

    async saveDate(date: string) {
        const result = await Setter(`spt/gl_item_status_histories/${this.id}`, {
            date,
        }, { method: 'PATCH' }) as { data?: IGLItemStatusHistory }
        if (result?.data) {
            this.init(result.data)
        }
    }

    async delete() {
        await Setter(`spt/gl_item_status_histories/${this.id}`, {}, { method: 'DELETE' })
    }
}
